import { IXetTotNghiepPhamViSinhVienDeleteRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienDeleteRequest";
import { IXetTotNghiepPhamViSinhVienInsertRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienInsertRequest";
import { IXetTotNghiepPhamViSinhVienSelectRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienSelectRequest";
import { IXetTotNghiepPhamViSinhVien } from "../../../model/response/xet-tot-nghiep/IXetTotNghiepPhamViSinhVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IXetTotNghiepImportResult {
    ma_sv: string;
    is_success: boolean;
    message: string;
}

export const eXetTotNghiepPhamViSinhVienActionsObj = {
    LOAD_BY_DOT_XET_START: {} as IXetTotNghiepPhamViSinhVienSelectRequest,
    LOAD_BY_DOT_XET_SUCCESS: {} as IXetTotNghiepPhamViSinhVien[],
    LOAD_BY_DOT_XET_ERROR: "",

    LOAD_NOT_EXISTS_DOT_XET_START: {} as IXetTotNghiepPhamViSinhVienSelectRequest,
    LOAD_NOT_EXISTS_DOT_XET_SUCCESS: {} as IXetTotNghiepPhamViSinhVien[],
    LOAD_NOT_EXISTS_DOT_XET_ERROR: "",

    SHOW_ADD_MODAL: {} as IXetTotNghiepPhamViSinhVien | undefined,
    CLOSE_ADD_MODAL: undefined,

    ADD_START: {} as IXetTotNghiepPhamViSinhVienInsertRequest,
    ADD_SUCCESS: undefined,
    ADD_ERROR: "",

    DELETE_START: {} as IXetTotNghiepPhamViSinhVienDeleteRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    UPDATE_DUYET_START: {} as { id_xet_tot_nghiep: number, id_svs: string[], isduyet: boolean | null },
    UPDATE_DUYET_SUCCESS: undefined,
    UPDATE_DUYET_ERROR: "",

    IMPORT_START: {
        id_xet_tot_nghiep: 0,
        file: {} as File
    },
    IMPORT_SUCCESS: [] as IXetTotNghiepImportResult[],
    IMPORT_ERROR: "",
};

export const eXetTotNghiepPhamViSinhVienActionIds = generateActionTypeIds(eXetTotNghiepPhamViSinhVienActionsObj, "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN");
export type IXetTotNghiepPhamViSinhVienActionTypes = IGenericActionType<typeof eXetTotNghiepPhamViSinhVienActionsObj, "XET_TOT_NGHIEP_PHAM_VI_SINH_VIEN">;